import { FirebaseActionTypes, FirebaseActions, FirebaseTypes } from '@web_opxp/features';
import { Themes } from '../../services/themeManager';
import { SocialActionTypes } from '../../social';

/**
 * firebase analytics action builders
 */

type TRegistrationMethodAction =
  | SocialActionTypes.SOCIAL_LOGIN_FACEBOOK
  | SocialActionTypes.SOCIAL_LOGIN_GOOGLE
  | SocialActionTypes.SOCIAL_LOGIN_APPLE
  | string;

export const firebaseRegistrationMethodAction: (
  action: TRegistrationMethodAction,
  location: Themes | 'Widget'
) => FirebaseActionTypes.IAnalyticsEventAction = (action, theme) => {
  // TODO: we will need to do two optiomizations to this approach:
  // 1. we need to implement generic social login action with provider as payload
  // 2. we need to get rid of theme and from widget if possible
  let method: 'Facebook' | 'Google' | 'Apple' | 'Email';
  let location: 'Onboarding' | 'Edison' | 'Widget';
  switch (action) {
    case SocialActionTypes.SOCIAL_LOGIN_APPLE:
      method = 'Apple';
      break;
    case SocialActionTypes.SOCIAL_LOGIN_FACEBOOK:
      method = 'Facebook';
      break;
    case SocialActionTypes.SOCIAL_LOGIN_GOOGLE:
      method = 'Google';
      break;
    default:
      method = 'Email';
      break;
  }
  switch (theme) {
    case Themes.Edison:
      location = 'Edison';
      break;
    case Themes.Opxp:
      location = 'Onboarding';
      break;
    default:
      location = 'Widget';
      break;
  }
  return FirebaseActions.analyticsEventAction({
    eventName: 'registration',
    parameters: [
      {
        key: 'Registration_Method',
        value: method,
      },
      {
        key: 'Registration_location',
        value: location,
      },
    ],
  });
};

// Email change requested action
export const firebaseEmailChangePayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'registration_change_email',
};
export const firebaseEmailChangeAction: () => FirebaseActionTypes.IAnalyticsEventAction = () =>
  FirebaseActions.analyticsEventAction(firebaseEmailChangePayload);

// Email resend requested action
export const EmailResendRequestPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'registration_resend_email',
};
export const EmailResendRequestAction: () => FirebaseActionTypes.IAnalyticsEventAction = () =>
  FirebaseActions.analyticsEventAction(EmailResendRequestPayload);

export const firebaseRegistrationCompletedAction: (
  method: 'Facebook' | 'Google' | 'Apple' | 'Email'
) => FirebaseActionTypes.IAnalyticsEventAction = (method) =>
  FirebaseActions.analyticsEventAction({
    eventName: 'registration_completed',
    parameters: [
      {
        key: 'Registration_Method',
        value: method,
      },
    ],
  });

// top button clicked action
export const firebaseLearnMoreEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'registration_learn_more',
};
export const firebaseLearnMoreClickAction: () => FirebaseActionTypes.IAnalyticsEventAction = () =>
  FirebaseActions.analyticsEventAction(firebaseLearnMoreEventPayload);

// email already registered action
export const EmailAlreadyRegisteredPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'registration_email',
  parameters: [
    {
      key: 'Feedback',
      value: 'Already given email',
    },
  ],
};
export const EmailAlreadyRegisteredAction: () => FirebaseActionTypes.IAnalyticsEventAction = () =>
  FirebaseActions.analyticsEventAction(EmailAlreadyRegisteredPayload);

// no email provided for registration action
export const NoEmailProvidedPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'registration_email',
  parameters: [
    {
      key: 'Feedback',
      value: 'No email',
    },
  ],
};
export const NoEmailProvidedAction: () => FirebaseActionTypes.IAnalyticsEventAction = () =>
  FirebaseActions.analyticsEventAction(NoEmailProvidedPayload);

// invalid email provided for registration action
export const InvalidEmailProvidedPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'registration_email',
  parameters: [
    {
      key: 'Feedback',
      value: 'Invalid email',
    },
  ],
};
export const InvalidEmailProvidedAction: () => FirebaseActionTypes.IAnalyticsEventAction = () =>
  FirebaseActions.analyticsEventAction(InvalidEmailProvidedPayload);

// no password provided for registration action
export const NoPasswordProvidedPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'registration_password',
  parameters: [
    {
      key: 'Feedback',
      value: 'No password',
    },
  ],
};
export const NoPasswordProvidedAction: () => FirebaseActionTypes.IAnalyticsEventAction = () =>
  FirebaseActions.analyticsEventAction(NoPasswordProvidedPayload);

// invalid password provided for registration action
export const InvalidPasswordProvidedPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'registration_password',
  parameters: [
    {
      key: 'Feedback',
      value: 'Invalid password',
    },
  ],
};
export const InvalidPasswordProvidedAction: () => FirebaseActionTypes.IAnalyticsEventAction = () =>
  FirebaseActions.analyticsEventAction(InvalidPasswordProvidedPayload);

// invalid password provided for login action
export const LoginInvalidPasswordProvidedPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'login_password',
  parameters: [
    {
      key: 'Feedback',
      value: 'Invalid password',
    },
  ],
};
export const LoginInvalidPasswordProvidedAction: () => FirebaseActionTypes.IAnalyticsEventAction = () =>
  FirebaseActions.analyticsEventAction(LoginInvalidPasswordProvidedPayload);

// no password provided for login action
export const LoginNoPasswordProvidedPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'login_password',
  parameters: [
    {
      key: 'Feedback',
      value: 'No password',
    },
  ],
};
export const LoginNoPasswordProvidedAction: () => FirebaseActionTypes.IAnalyticsEventAction = () =>
  FirebaseActions.analyticsEventAction(LoginNoPasswordProvidedPayload);

// invalid email provided for login action
export const LoginInvalidEmailProvidedPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'login_email',
  parameters: [
    {
      key: 'Feedback',
      value: 'Invalid email',
    },
  ],
};
export const LoginInvalidEmailProvidedAction: () => FirebaseActionTypes.IAnalyticsEventAction = () =>
  FirebaseActions.analyticsEventAction(LoginInvalidEmailProvidedPayload);

// invalid email provided for login action
export const LoginNoEmailProvidedPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'login_email',
  parameters: [
    {
      key: 'Feedback',
      value: 'No email',
    },
  ],
};
export const LoginNoEmailProvidedAction: () => FirebaseActionTypes.IAnalyticsEventAction = () =>
  FirebaseActions.analyticsEventAction(LoginNoEmailProvidedPayload);

// login attempt returned error action
export const LoginAuthErrorPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'login_auth_error',
  parameters: [],
};
export const LoginAuthErrorAction: (error: string) => FirebaseActionTypes.IAnalyticsEventAction = (error) => {
  const param = {
    key: 'Error',
    value: error,
  };
  if (LoginAuthErrorPayload.parameters) LoginAuthErrorPayload.parameters.push(param);
  return FirebaseActions.analyticsEventAction(LoginAuthErrorPayload);
};

export const setUserId = FirebaseActions.setUserAction;
